<template>
  <v-container id="app" fill-height>
    <v-row>
      <!-- <v-col lg="4"><QRCode /><EcuDetail :data="data" /> </v-col> -->
      <v-col lg="4" class="d-flex justify-center align-center">
        <EcuDetail :data="data" />
      </v-col>
      <!-- <VerticalLine /> -->
      <v-col lg="6"
        ><ConnectorImg :connector="data.connector" />
        <MasksImg :mask_types="data.mask_types" /><ReturnBtn /> </v-col
    ></v-row>
    <ErrorInfo ref="ErrorInfo" />
  </v-container>
</template>
<script>
import EcuDetail from "@/components/app/Result/EcuDetail.vue";
import ReturnBtn from "@/components/app/Result/ReturnBtn.vue";
import ConnectorImg from "@/components/app/Result/ConnectorImg.vue";
import MasksImg from "@/components/app/Result/MasksImg.vue";
// import QRCode from "@/components/app/Result/QRCode.vue";
import ConnectorService from "../utils/services/connector.service";
import ErrorInfo from "@/components/shared/ErrorInfo.vue";
//import VerticalLine from "@/components/shared/VerticalLine.vue";

export default {
  components: {
    ErrorInfo,
    EcuDetail,
    MasksImg,
    //QRCode,
    ConnectorImg,
    ReturnBtn,
    //VerticalLine,
  },
  data() {
    return {
      ecu: this.$route.params.ecu,
      data: {},
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      return ConnectorService.getResult(this.ecu)
        .then((response) => {
          this.data = response;
        })
        .catch((error) => {
          this.$router.push("/");
          this.$refs.ErrorInfo.catchError(error);
        });
    },
  },
};
</script>
